// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links[data-v-8072ed30],form#login[data-v-8072ed30]{margin-top:20px}.links[data-v-8072ed30]{margin-bottom:43px}.submit-error[data-v-8072ed30]{margin-bottom:20px}.submit-error span[data-v-8072ed30]{color:#9081e6!important}", ""]);
// Exports
module.exports = exports;
